import React from 'react';
import { useDispatch, useSelector,connect  } from 'react-redux';
import { reduxForm, Field } from 'redux-form';
import { treatmentResultMarkingsForm } from '../../../constants/FormConstants';
import * as operationsApi from '../../../api/operationsApi';
import Logger from '../../../util/Logger';
import * as jobActions from '../../../actions/jobActions';
import TreatmentResultMarkingsForm from './TreatmentResultMarkingsForm';

const TreatmentResultMarkingsFormContainer = (props) => {
  const dispatch = useDispatch();
  const currentJob = useSelector((state) => state.currentJob);
  /*const initialValues = {
    markings: currentJob.treatmentTypeDetails.markings || []  // assuming markings is an array of objects
  };*/

    // Check reduxForm props
  /*console.log('Redux Form Props:', {
    handleSubmit: props.handleSubmit,
    pristine: props.pristine,
    submitting: props.submitting,
    initialValues: props.initialValues,
  });*/
  const{handleSubmit,registerSubmit} = props



  const onSubmit = (formValues) => {
    const { markings } = formValues;
    const saveJobOperation = currentJob.id ? operationsApi.updateJob : () => Promise.resolve();

    return saveJobOperation({
      ...currentJob,
      treatmentTypeDetails: {
        ...currentJob.treatmentTypeDetails,
        markings,
      },
    })
      .then(() => {
        Logger.success('Markings Updated Successfully');
        return dispatch(jobActions.getJob(currentJob.id));
      });
  };
  
   React.useEffect(() => {
    if (registerSubmit) {
      registerSubmit(() => handleSubmit(onSubmit)());
    }

    return () => {
      if (registerSubmit) {
        registerSubmit(null);
      }
    };
  }, [registerSubmit, handleSubmit]);

  const onSubmitFail = (errors, dispatch, submitError) => {
    Logger.error(
      'We were unable to save the changes, please review the fields in red and try again.',
      submitError,
      'Markings not saved',
    );
  };

  return (
    <TreatmentResultMarkingsForm
    {...props}
     // initialValues={ initialValues }
      currentJob={currentJob}
     // handleSubmit={props.handleSubmit} 
      //handleSubmit={handleSubmit}
      onSubmit={onSubmit}
      onSubmitFail={onSubmitFail}
      //markings={initialValues.markings}
    />
  );
};
const mapStateToProps = (state) => ({
  initialValues: {
    markings: state.currentJob.treatmentTypeDetails.markings || [],
  },
});

export default connect(mapStateToProps)(
  reduxForm({
    form: 'treatmentResultMarkingsForm',
    enableReinitialize: true,
  })(TreatmentResultMarkingsFormContainer)
);
/*
export default reduxForm({
  form: 'treatmentResultMarkingsForm',
  enableReinitialize: true,  // Reinitialize form when initialValues change
  initialValues: (state) => ({
    // Set initialValues directly from the Redux state
    markings: state.currentJob?.treatmentTypeDetails?.markings || []
  })
})(TreatmentResultMarkingsFormContainer);*/
